









import {Component, Prop, Vue, Watch} from "vue-property-decorator";

@Component({
  name: "Toggle",
})
export default class Toggle extends Vue {
  @Prop({
    type: Boolean,
    default() {
      return;
    },
  })
  required!: boolean;
  @Prop({
    type: Array,
  })
  items!: string[] | object[] ;
  @Prop({
    type: Boolean,
    default() {
      return "";
    },
  })
  value!: boolean;
  @Prop({
    type: String,
    default() {
      return "";
    },
  })
  label!: string;

  // data
  private classes: any = {
    "lfs-pd-input-block-requred": this.required,
  };
  private placeholder: string = "";
  item: boolean = this.value;
  //   methods

  @Watch('value')
  setItem(newVal:boolean){
      this.item = newVal
  }

  handleInput() {
    this.$emit("input", this.item);
  }
}
